import React, { useState, useEffect } from 'react'
import Box from './Box'

export default function BoxDragPreview({ label, height, width }) {
  const [tickTock, setTickTock] = useState(false)

  useEffect(
    function subscribeToIntervalTick() {
      const interval = setInterval(() => setTickTock(!tickTock), 500)
      return () => clearInterval(interval)
    },
    [tickTock],
  )

  return (
    <div style={{ height, width }}>
      <Box title={label} yellow={tickTock} preview />
    </div>
  )
}
